import React, { useEffect } from 'react';

// Styles
import Button from '../../common/Button';
import * as T from '../../common/Typography';
import { Row, Col } from '../../common/Grid';

import moment from 'moment';

import { SessionDetails, SectionHeadline, DetailsDiv } from './Survey.style';

const courses = {
  C5: 'Connect 5',
  YOUNG_PEOPLE: 'Connect 5 Young People'
};
const ConfirmSurvey = props => {
  // function to create a list of names from an array...
  const renderTrainerNames = array =>
    array.map((e, i) =>
      array.length > 1 && array.length - 1 === i ? `and ${e}` : `${e} `
    );

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const {
    sessionDates,
    trainerNames,
    modules,
    sectionChange,
    researchConfirm,
    course
  } = props;
  const filteredDates = sessionDates?.filter(e => e.sessionDate !== null);
  return (
    <>
      <SectionHeadline>Gwent Connect 5 Evaluation</SectionHeadline>
      <Row>
        <Col w={[4, 12, 8]}>
          <SessionDetails>
            <DetailsDiv>
              <T.P color="gray">
                <T.P weight={700} d="inline">
                  Date(s) of Session:{' '}
                </T.P>{' '}
                {filteredDates?.length
                  ? filteredDates.map((date, i) => (
                      <T.P d="inline">
                        {moment(date.sessionDate).format('DD/MM/YYYY')}{' '}
                        {i !== filteredDates.length - 1 ? '& ' : null}
                      </T.P>
                    ))
                  : 'N/A'}
              </T.P>
            </DetailsDiv>
            <DetailsDiv>
              <T.P weight={700} d="inline">
                Course: <T.P d="inline">{courses[course]}</T.P>
              </T.P>
            </DetailsDiv>
            <DetailsDiv>
              <T.P weight={700} d="inline">
                Module(s):{' '}
                <T.P d="inline"> {modules ? modules.join(' & ') : 'N/A'}</T.P>
              </T.P>
            </DetailsDiv>
            <DetailsDiv>
              <T.P weight={700} d="inline">
                Trainers:{' '}
                <T.P d="inline" transform="capitalize">
                  {renderTrainerNames(trainerNames)}
                </T.P>
              </T.P>
            </DetailsDiv>
          </SessionDetails>
          <T.P mb={5}>
            This anonymous evaluation form should only take a few minutes to
            complete. Your feedback helps us monitor and improve the Gwent
            Connect 5 programme. Thank you.
          </T.P>
          <T.P weight={900}>Important Message from Funders:</T.P>
          <T.P>
            The Gwent Connect 5 training course is fully funded by the Welsh
            Government (WG) and Aneurin Bevan University Health Board (ABUHB).
          </T.P>
          <T.P mt="3">
            In compliance with the funding criteria and to enable ABUHB’s Gwent
            Public Health Team to monitor and improve its impact, ALL training
            participants are required to complete brief evaluation forms. ABUHB
            will evaluate the impact of the training by reviewing anonymised
            responses.
          </T.P>
        </Col>
      </Row>
      <Row>
        <Col w={[4, 12, 8]}>
          <Row inner>
            <Col w={[4, 12, 12]}>
              <T.P mt="6" mb="4" weight={900}>
                Your anonymised data will be used for research purposes only.
              </T.P>
            </Col>
            <Col w={[4, 6, 4]}>
              <Button
                label="Agree"
                type="secondary"
                onClick={() => {
                  sectionChange({ index: 0 });
                  researchConfirm();
                }}
              />
            </Col>
          </Row>
        </Col>
      </Row>
    </>
  );
};

export default ConfirmSurvey;
